// src/resources/sections/caConfig.ts
import type { ResourceConfig } from "../resourceTypes";

export const CA_CONFIG: ResourceConfig[] = [
  /*
  {
    name: "certificate_automations",
    label: "Certificate Automations",
    schema: "ca",
    searchFields: ["host_id", "destination_path", "output_format"],
    fields: [
      { source: "name", label: "Name", list: true, form: true },
      { source: "pfx_alias", label: "PFX Alias", list: true, form: true },
      { source: "keystore_mode",
        label: "Keystore Mode",
        list: true,
        form: true,
        kind: "select",
        choices: [
          {
            value: "append",
            label: "append",
            value: "replace",
            label: "replace",
          },
        ],
        defaultValue: "append",
      },

      {
        source: "host_id",
        label: "Host",
        kind: "uuid",
        list: true,
        form: true,
        ref: {
          resource: "hosts",
          optionText: "hostname",
          input: "autocomplete",
          schema: "host",
        },
      },
      {
        source: "certificate_id",
        label: "Certificate",
        kind: "uuid",
        list: true,
        form: true,
        ref: {
          resource: "certificates",
          optionText: "common_name",
          input: "autocomplete",
          schema: "ca",
        },
      },
{
  source: "cred_id",
  label: "Credential",
  kind: "select",
  form: true,
  list: true,
  required: false, // allow NULL if you want fallback to host.cred_id
  ref: {
    schema: "auth",
    resource: "credentials_safe",
    optionText: "cred_name", // or "username" if you prefer
    optionValue: "id",
  },
},
{
  source: "jks_cred_id",
  label: "JKS Credential(if needed)",
  kind: "select",
  form: true,
  list: true,
  required: false, // allow NULL if you want fallback to host.cred_id
  ref: {
    schema: "auth",
    resource: "v_jks_creds_safe",
    optionText: "name", // or "username" if you prefer
    optionValue: "id",
  },
},

      {
        source: "target_type_id",
        label: "Target type",
        kind: "number",
        list: true,
        form: true,
        ref: {
          resource: "automation_target_types",
          optionText: "code",
          input: "autocomplete",
        },
      },
      {
        source: "enabled",
        label: "Enabled",
        kind: "boolean",
        list: true,
        form: true,
      },
      {
        source: "destination_path",
        label: "Destination Path",
        list: true,
        form: true,
      },
      {
        source: "output_format",
        label: "Output",
        list: true,
        form: true,
        kind: "select",
        choices: [
          {
            value: "pem",
            label: "pem",
            value: "pfx",
            label: "pfx",
          },
        ],
        defaultValue: "pem",
      },
      {
        source: "include_chain",
        label: "Chain",
        kind: "boolean",
        list: true,
        form: true,
      },
      {
        source: "include_key",
        label: "Key",
        kind: "boolean",
        list: true,
        form: true,
      },
      {
        source: "create_dirs",
        label: "Create Dirs",
        kind: "boolean",
        list: true,
        form: true,
      },
      {
        source: "backup_existing",
        label: "Backup Existing",
        kind: "boolean",
        list: true,
        form: true,
      },
      { source: "owner", label: "Owner", kind: "text", list: true, form: true },
      {
        source: "file_mode",
        label: "File Mode",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "service_reload",
        label: "Service Reload",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "keystore_path",
        label: "Keystore Path",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "keytool_path",
        label: "Keytool Path",
        kind: "text",
        list: true,
        form: true,
      },
    ],
    actions: [
      {
        kind: "rpc",
        label: "DONT USE Run",
        rpcName: "run_certificate_automations",
        method: "POST",
        sendRecord: true,
      },
      {
        kind: "rpc",
        label: "Run Certifcate Automation",
        rpcName: "run_certificate_automation",
        method: "POST",
        sendRecord: false,
        useIdAs: "p_automation_id",
        row: true,
        refreshAfter: true,
      },
    ],
  },
*/
  /*
  {
    name: "automation_credentials",
    label: "Automation Credentials",
    schema: "ca",
    fields: [
      {
        source: "id",
        label: "id",
        kind: "text",
        list: true,
        form: true,
      },
    ],
  },
*/
  /*
  {
    name: "jks_credentials",
    label: "JKS Credentials",
    schema: "auth",
    fields: [
      {
        source: "name",
        label: "Name",
        kind: "text",
        list: true,
        form: true,
      },
    ],
  },
  {
    name: "automation_jks_credentials",
    label: "Automation JKS Credentials",
    schema: "ca",
    fields: [
      {
        source: "id",
        label: "id",
        kind: "text",
        list: true,
        form: true,
      },
    ],
  },
*/
  /*
  {
    name: "certificate_types",
    label: "Certificate Types",
    schema: "ca",
    fields: [
      { source: "id", label: "id", kind: "text", list: true, form: true },
      { source: "code", label: "code", kind: "text", list: true, form: true },
      { source: "label", label: "label", kind: "text", list: true, form: true },
    ],
  },

  {
    name: "certificate_authorities",
    label: "Certificate Authorities",
    schema: "ca",
    fields: [
      {
        source: "ca_name",
        label: "CA name",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "common_name",
        label: "Common name",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "organization",
        label: "Organization",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "organizational_unit",
        label: "Org unit",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "country",
        label: "Country",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "state_province",
        label: "State/Province",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "locality",
        label: "Locality",
        kind: "text",
        list: true,
        form: true,
      },
      { source: "email", label: "Email", kind: "text", list: true, form: true },
      {
        source: "is_root",
        label: "Is root",
        kind: "boolean",
        list: true,
        form: true,
        defaultValue: false,
      },
      {
        source: "status_id",
        label: "Status",
        kind: "number",
        list: true,
        form: true,
        ref: {
          resource: "certificate_statuses",
          optionText: "code",
          input: "autocomplete",
          schema: "ca",
        },
      },
      {
        source: "cert_type_id",
        label: "Cert Types",
        kind: "number",
        list: true,
        form: true,
        ref: {
          resource: "certificate_types",
          optionText: "code",
          input: "autocomplete",
          schema: "ca",
        },
      },
      {
        source: "created_at",
        label: "Created at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "updated_at",
        label: "Updated at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
    ],
    searchFields: ["ca_name", "common_name"],
  },
  {
    name: "ssh_certificate_authorities",
    label: "SSH Certificate Authorities",
    schema: "ca",
    fields: [
      {
        source: "name",
        label: "CA name",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "key_type",
        label: "key_type",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "public_key",
        label: "public_key",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "status_id",
        label: "Status",
        kind: "number",
        list: true,
        form: true,
        ref: {
          resource: "certificate_statuses",
          optionText: "code",
          input: "autocomplete",
          schema: "ca",
        },
      },
      {
        source: "owner_id",
        label: "Owner",
        kind: "number",
        list: true,
        form: true,
        ref: {
          resource: "users",
          optionText: "email",
          input: "autocomplete",
          schema: "ca",
        },
      },
      {
        source: "created_at",
        label: "Created at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "updated_at",
        label: "Updated at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
    ],
    searchFields: ["ca_name", "common_name"],
  },

  {
    name: "certificates",
    label: "Certificates",
    schema: "ca",
    fields: [
      {
        source: "issuing_ca_id",
        label: "Issuing CA",
        kind: "uuid",
        list: true,
        form: true,
        ref: {
          resource: "certificate_authorities",
          optionText: "ca_name",
          input: "autocomplete",
          schema: "ca",
        },
      },
      {
        source: "common_name",
        label: "Common name",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "subject_alternative_names",
        label: "SANs",
        kind: "longtext",
        list: true,
        form: true,
      },
      {
        source: "serial_number",
        label: "Serial",
        kind: "text",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "not_before",
        label: "Not before",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "not_after",
        label: "Not after",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "status_id",
        label: "Status",
        kind: "number",
        list: true,
        form: true,
        ref: {
          resource: "certificate_statuses",
          optionText: "code",
          input: "autocomplete",
          schema: "ca",
        },
      },
      {
        source: "certificate_pem",
        label: "Certificate PEM",
        kind: "text",
        list: false,
        form: false,
        editDisabled: true,
      },
    ],
    arraySearchFields: ["subject_alternative_names"],
    searchFields: ["common_name"],
    actions: [
      // Download – cert only (no private key)
      {
        kind: "download",
        label: "Download PEM",
        rpcName: "export_certificate",
        method: "POST",
        sendRecord: false,
        // p_cert_id comes from row.id
        useIdAs: "p_cert_id",
        // cert-only PEM
        payload: {
          p_format: "PEM",
          p_include_chain: false,
        },
        filename: "{common_name}.pem",
        row: true,
      },
      {
        kind: "download",
        label: "Download Chain (PEM)",
        rpcName: "export_certificate",
        method: "POST",
        sendRecord: false,
        useIdAs: "p_cert_id",
        // leaf + chain, no key
        payload: {
          p_format: "CHAIN_PEM",
          p_include_chain: true,
        },
        filename: "{common_name}-chain.pem",
        row: true,
      },
      {
        kind: "download",
        label: "Download DER",
        rpcName: "export_certificate",
        method: "POST",
        sendRecord: false,
        useIdAs: "p_cert_id",
        payload: {
          p_format: "DER",
          p_include_chain: false,
        },
        filename: "{common_name}.der",
        row: true,
      },
      {
        kind: "download",
        label: "Download P7B",
        rpcName: "export_certificate",
        method: "POST",
        sendRecord: false,
        useIdAs: "p_cert_id",
        // chain of certs, no key
        payload: {
          p_format: "P7B",
          p_include_chain: true,
        },
        filename: "{common_name}.p7b",
        row: true,
      },
      // Download – includes private key (prompts for password)
      {
        kind: "download",
        label: "Download PEM with Private Key",
        rpcName: "export_certificate",
        method: "POST",
        sendRecord: false,
        useIdAs: "p_cert_id",
        payload: {
          p_format: "PEM_KEY",
          p_include_chain: false,
        },
        filename: "{common_name}-key.pem",
        row: true,
        // GenericCrud will prompt and put it in p_output_password
        promptPassword: true,
        passwordField: "p_output_password",
      },
      {
        kind: "download",
        label: "Download Chain (PEM) with Private Key",
        rpcName: "export_certificate",
        method: "POST",
        sendRecord: false,
        useIdAs: "p_cert_id",
        payload: {
          p_format: "CHAIN_PEM_KEY",
          p_include_chain: true,
        },
        filename: "{common_name}-chain-key.pem",
        row: true,
        promptPassword: true,
        passwordField: "p_output_password",
      },
      {
        kind: "download",
        label: "Download PFX",
        rpcName: "export_certificate",
        method: "POST",
        sendRecord: false,
        useIdAs: "p_cert_id",
        payload: {
          p_format: "PFX",
          p_include_chain: true,
        },
        filename: "{common_name}.pfx",
        row: true,
        promptPassword: true,
        passwordField: "p_output_password",
      },
      // Download Root CA PEM (top of chain, no key)
      {
        kind: "download",
        label: "Download Root CA PEM",
        rpcName: "export_certificate",
        method: "POST",
        sendRecord: false,
        useIdAs: "p_cert_id",
        payload: {
          p_format: "ROOT_PEM",
          p_include_chain: true,
        },
        filename: "{common_name}-root.pem",
        row: true,
      },
      // Copy – PEM text to clipboard (no private key)
      {
        kind: "rpc",
        label: "Copy PEM (no key)",
        rpcName: "export_certificate_pem_text",
        method: "POST",
        sendRecord: false,
        useIdAs: "p_cert_id",
        payload: {
          p_format: "PEM",
          p_include_chain: false,
        },
        copyToClipboard: true,
        row: true,
      },
      {
        kind: "rpc",
        label: "Copy Chain PEM (no key)",
        rpcName: "export_certificate_pem_text",
        method: "POST",
        sendRecord: false,
        useIdAs: "p_cert_id",
        payload: {
          p_format: "CHAIN_PEM",
          p_include_chain: true,
        },
        copyToClipboard: true,
        row: true,
      },
    ],
  },

  {
    name: "issuance_policies",
    label: "Issuance Policies",
    schema: "ca",
    fields: [
      // { source: "ca_id", label: "CA", kind: "uuid", list: true, form: true },
      {
        source: "ca_id",
        label: "Certificate Authority CN",
        kind: "uuid",
        form: true,
        list: true,
        ref: {
          resource: "certificate_authorities",
          optionText: "common_name",
          input: "autocomplete",
          schema: "ca",
        },
      },
      {
        source: "policy_name",
        label: "Policy name",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "description",
        label: "description",
        kind: "longtext",
        list: true,
        form: true,
      },
      {
        source: "priority",
        label: "priority",
        kind: "number",
        list: true,
        form: true,
      },
      {
        source: "cn_regex",
        label: "CN regex",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "allowed_san_dns_suffix",
        label: "Allowed SAN suffix",
        kind: "longtext",
        list: true,
        form: true,
      },
      {
        source: "is_active",
        label: "Active",
        kind: "boolean",
        list: true,
        form: true,
      },
      {
        source: "created_at",
        label: "Created at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
    ],
    searchFields: ["policy_name"],
  },

  {
    name: "certificate_templates",
    label: "Certificate Templates",
    schema: "ca",
    fields: [
      {
        source: "template_name",
        label: "Template name",
        kind: "text",
        list: true,
        form: true,
        required: true,
      },
      {
        source: "cert_type_id",
        label: "Cert type",
        kind: "number",
        list: true,
        form: true,
        required: true,
      },
      {
        source: "key_algorithm_id",
        label: "Key algorithm",
        kind: "number",
        list: true,
        form: true,
        required: true,
      },
      {
        source: "key_size",
        label: "Key size",
        kind: "number",
        list: true,
        form: true,
        required: true,
      },
      {
        source: "hash_algorithm_id",
        label: "Hash algorithm",
        kind: "number",
        list: true,
        form: true,
        required: true,
      },
      {
        source: "validity_period_days",
        label: "Validity (days)",
        kind: "number",
        list: true,
        form: true,
        required: true,
      },
      {
        source: "key_usage",
        label: "Key usage",
        kind: "longtext",
        list: true,
        form: true,
      },
      {
        source: "extended_key_usage",
        label: "Extended key usage",
        kind: "longtext",
        list: true,
        form: true,
      },
      {
        source: "subject_template",
        label: "Subject template (JSON)",
        kind: "longtext",
        list: false,
        form: true,
      },
      {
        source: "san_template",
        label: "SAN template (JSON)",
        kind: "longtext",
        list: false,
        form: true,
      },
      {
        source: "is_active",
        label: "Active",
        kind: "boolean",
        list: true,
        form: true,
        defaultValue: true,
      },
      {
        source: "created_at",
        label: "Created at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
    ],
    searchFields: ["template_name"],
  },
*/
  /*
  {
    name: "automation_target_types",
    label: "Automation Target Types",
    schema: "ca",
    fields: [
      { source: "id", label: "id", kind: "number", list: true, form: true },
      { source: "code", label: "code", kind: "text", list: true, form: true },
      { source: "label", label: "label", kind: "text", list: true, form: true },
    ],
  },
/*
  {
    name: "v_certificate_automations",
    label: "V Certificate Automation",
    schema: "ca",
    fields: [
      {
        source: "certificate_id",
        label: "Certificate",
        kind: "uuid",
        form: true,
        list: false,
        ref: {
          resource: "certificates",
          optionText: "common_name",
          input: "autocomplete",
          schema: "ca",
        },
      },
      {
        source: "include_chain",
        label: "Include chain",
        kind: "boolean",
        list: true,
        form: true,
      },
      {
        source: "include_key",
        label: "Include key",
        kind: "boolean",
        list: true,
        form: true,
      },
      {
        source: "output_format",
        label: "Output format",
        kind: "select",
        list: true,
        form: true,
        choices: [
          { value: "pem", label: "PEM (files)" },
          { value: "pkcs12", label: "PKCS#12 (PFX/JKS)" },
          { value: "ssh", label: "SSH (RSA/Ed25519)" },
        ],
        defaultValue: "pem",
      },
      {
        source: "pfx_alias",
        label: "PFX alias",
        kind: "text",
        list: false,
        form: true,
      },

      {
        source: "target_type_id",
        label: "Target type",
        kind: "number",
        list: true,
        form: true,
        ref: {
          resource: "automation_target_types",
          optionText: "code",
          input: "select",
          schema: "ca",
        },
      },
      {
        source: "auth_cred_id",
        label: "Auth credential",
        kind: "uuid",
        list: false,
        form: true,
        ref: {
          resource: "automation_credentials",
          optionText: "cred_name",
          input: "select",
          schema: "ca",
        },
      },
      {
        source: "jks_cred_id",
        label: "JKS credential",
        kind: "uuid",
        list: false,
        form: true,
        ref: {
          resource: "automation_jks_credentials",
          optionText: "cred_name",
          input: "select",
          schema: "ca",
        },
      },
      { source: "port", label: "Port", kind: "number", list: true, form: true },
/*
      {
        source: "auth_method",
        label: "Auth method",
        kind: "select",
        list: true,
        form: true,
        choices: [
          { value: "password", label: "password" },
          { value: "keyfile", label: "keyfile" },
          { value: "ssh-agent", label: "ssh-agent" },
        ],
        defaultValue: "password",
      },

      // SMB
      {
        source: "smb_share",
        label: "SMB share",
        kind: "text",
        list: false,
        form: true,
      },
      {
        source: "smb_path",
        label: "SMB path",
        kind: "text",
        list: false,
        form: true,
      },
*/
  /*
      // Destination/perms/service
      {
        source: "destination_path",
        label: "Destination path",
        kind: "text",
        list: true,
        form: true,
      },
      { source: "owner", label: "Owner", kind: "text", list: true, form: true },
      {
        source: "file_mode",
        label: "File mode",
        kind: "text",
        list: false,
        form: true,
      },
      {
        source: "service_reload",
        label: "Service reload",
        kind: "text",
        list: false,
        form: true,
      },
*/

  // Windows store
  /*
      {
        source: "win_store_location",
        label: "Win store location",
        kind: "text",
        list: false,
        form: true,
      },
      {
        source: "win_store_name",
        label: "Win store name",
        kind: "text",
        list: false,
        form: true,
      },

      // Java keystore
      {
        source: "keystore_path",
        label: "Keystore path",
        kind: "text",
        list: false,
        form: true,
      },
*/

  /*
      {
        source: "keystore_type",
        label: "Keystore type",
        kind: "select",
        list: false,
        form: true,
        choices: [
          { value: "PKCS12", label: "PKCS12" },
          { value: "JKS", label: "JKS" },
        ],
        defaultValue: "JKS",
      },
      {
        source: "keystore_mode",
        label: "Keystore mode",
        kind: "select",
        list: false,
        form: true,
        choices: [
          { value: "append", label: "append" },
          { value: "replace", label: "replace" },
          { value: "replace_all", label: "replace_all" },
        ],
        defaultValue: "append",
      },
      {
        source: "keytool_path",
        label: "Keytool path",
        kind: "text",
        list: false,
        form: true,
      },

      // Behavior
      {
        source: "skip_tls_verify",
        label: "Skip TLS verify",
        kind: "boolean",
        list: true,
        form: true,
      },
      {
        source: "create_dirs",
        label: "Create dirs",
        kind: "boolean",
        list: true,
        form: true,
      },
      {
        source: "backup_existing",
        label: "Backup existing",
        kind: "boolean",
        list: true,
        form: true,
      },

      // Scheduling / status
      {
        source: "enabled",
        label: "Enabled",
        kind: "boolean",
        list: true,
        form: true,
      },
      {
        source: "cron_expr",
        label: "Cron expr",
        kind: "text",
        list: false,
        form: false,
        editDisabled: true,
      },
      {
        source: "last_run_at",
        label: "Last run at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "next_run_at",
        label: "Next run at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "status_id",
        label: "Status",
        kind: "number",
        list: true,
        form: true,
        readOnly: true,
        // editDisabled: true,
        ref: {
          resource: "certificate_statuses",
          optionText: "code",
          input: "autocomplete",
          schema: "ca",
        },
      },
      {
        source: "last_error",
        label: "Last error",
        kind: "longtext",
        list: false,
        form: false,
        editDisabled: true,
      },

      // audit
      {
        source: "created_at",
        label: "Created at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "updated_at",
        label: "Updated at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "key_password",
        label: "Key password",
        kind: "text",
        list: false,
        form: true,
      },
      {
        source: "auth_key_path",
        label: "Auth key path",
        kind: "text",
        list: false,
        form: true,
      },
    ],
    searchFields: ["host_id", "owner", "output_format"],
    actions: [
      {
        kind: "rpc",
        label: "Run",
        rpcName: "run_certificate_automations",
        method: "POST",
        sendRecord: true,
      },
    ],
  },
*/
  /*
  {
    name: "automation_runs",
    label: "Automation Runs",
    schema: "ca",
    readOnly: true,
    defaultSort: { field: "started_at", order: "desc" },
    fields: [
      {
        source: "automation_id",
        label: "Automation",
        kind: "uuid",
        list: true,
        form: false,
        ref: {
          resource: "v_certificate_automations",
          optionText: "id",
          input: "autocomplete",
          schema: "ca",
        },
      },
      {
        source: "started_at",
        label: "Started at",
        kind: "date",
        list: true,
        form: false,
      },
      {
        source: "finished_at",
        label: "Finished at",
        kind: "date",
        list: true,
        form: false,
      },
      {
        source: "status_id",
        label: "Status",
        kind: "number",
        list: true,
        form: true,
        readOnly: true,
        // editDisabled: true,
        ref: {
          resource: "certificate_statuses",
          optionText: "code",
          input: "autocomplete",
          schema: "ca",
        },
      },
      {
        source: "logs",
        label: "Logs",
        kind: "longtext",
        list: true,
        form: false,
      },
      {
        source: "error",
        label: "Error",
        kind: "longtext",
        list: true,
        form: false,
      },
      {
        source: "created_at",
        label: "Created at",
        kind: "date",
        list: true,
        form: false,
      },
    ],
    searchFields: ["automation_id", "status_id"],
  },
/*
  {
    name: "encryption_config",
    label: "Encryption Config",
    schema: "ca",
    fields: [
      {
        source: "key_algorithm_code",
        label: "Key algorithm",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "key_size",
        label: "Key size",
        kind: "number",
        list: true,
        form: true,
      },
      {
        source: "hash_algorithm_code",
        label: "Hash algorithm",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "is_active",
        label: "Is active",
        kind: "boolean",
        list: true,
        form: true,
      },
      {
        source: "created_at",
        label: "Created at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "rotated_at",
        label: "Rotated at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
    ],
    searchFields: ["key_algorithm_code"],
  },
*/
  {
    name: "revocation_reasons",
    label: "Revocation Reasons",
    schema: "ca",
    fields: [
      { source: "code", label: "code", kind: "text", list: true, form: true },
      {
        source: "description",
        label: "description",
        kind: "text",
        list: true,
        form: true,
      },
    ],
    searchFields: ["code"],
  },
  {
    name: "certificate_statuses",
    label: "Certificate Statuses",
    schema: "ca",
    fields: [
      { source: "code", label: "code", kind: "text", list: true, form: true },
      {
        source: "description",
        label: "description",
        kind: "text",
        list: true,
        form: true,
      },
    ],
    searchFields: ["code"],
  },
  {
    name: "crl_entries",
    label: "CRL Entries",
    schema: "ca",
    fields: [
      {
        source: "certificate_id",
        label: "Certificate",
        kind: "uuid",
        list: true,
        form: true,
        ref: {
          resource: "certificates",
          optionText: "serial_number",
          input: "autocomplete",
          schema: "ca",
        },
      },
      {
        source: "serial_number",
        label: "Serial number",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "revocation_reason_id",
        label: "Revocation reason",
        kind: "number",
        list: true,
        form: true,
        ref: {
          resource: "revocation_reasons",
          optionText: "code",
          input: "autocomplete",
          schema: "ca",
        },
      },
      {
        source: "revoked_at",
        label: "Revoked at",
        kind: "date",
        list: true,
        form: true,
      },
      {
        source: "created_at",
        label: "Created at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
    ],
    searchFields: ["serial_number"],
  },
];
